export default __webpack_public_path__ + "static/media/AppStore.2cdaefa9.png";